import { render } from "./MobileMoneyDetails.vue?vue&type=template&id=68e81506&ts=true"
import script from "./MobileMoneyDetails.vue?vue&type=script&lang=ts"
export * from "./MobileMoneyDetails.vue?vue&type=script&lang=ts"

import "./MobileMoneyDetails.vue?vue&type=style&index=0&id=68e81506&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/payment/MobileMoneyDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68e81506"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68e81506', __exports__)) {
    api.reload('68e81506', __exports__)
  }
  
  module.hot.accept("./MobileMoneyDetails.vue?vue&type=template&id=68e81506&ts=true", () => {
    api.rerender('68e81506', render)
  })

}


export default __exports__